import {legacyToolPresentation} from "@repo/ui/gailgpt/legacy-tool-presentation";
import {validateToolPresentation} from "@repo/ui/gailgpt/tool-presentation";
import type {MessageContentFunctionCall} from "@/services/wingman";
import type {ToolApprovalStatus} from "@repo/ui/gailgpt/tool-approval-status";

export function approvalPresentation(call: MessageContentFunctionCall) {
   const supplied = call.approval?.presentation ?? call.presentation;
   const presentation = supplied === undefined ? legacyToolPresentation(call.functionName, call.parameters)
      : validateToolPresentation(supplied, call.functionName, call.parameters);
   const unavailable = !!call.approval?.previewUnavailable || !!call.presentationUnavailable || !presentation ||
      (presentation.kind === "diff" && !call.approval?.proposal);
   return {presentation, unavailable};
}

/** Keep the compact summary and its full review consistent about execution outcomes. */
export function approvalStatusKey(call: MessageContentFunctionCall, status: ToolApprovalStatus, preview?: ReturnType<typeof approvalPresentation>): string {
   if (call.approval?.proposal || call.approval?.previewUnavailable) return `toolApproval.${status}`;
   if (status === "completed") return `toolApproval.execution.${(preview ?? approvalPresentation(call)).presentation?.completion === "accepted" ? "accepted" : "completed"}`;
   return ["required", "approved", "denied", "failed", "indeterminate"].includes(status)
      ? `toolApproval.execution.${status}` : `toolApproval.${status}`;
}
